module.exports = __webpack_public_path__ + "img/band-small-dark.96672582.svg";